const CHIP_BY_KEY = {
  renewal_decision: "CHALLENGE DECISION",
  dormant_return: "START SMALL",
  missed_yesterday: "PICK THIS BACK UP",
  partner_moved_first: "THE LOOP IS OPEN",
  midday_drift: "DON'T LET TODAY SLIP",
  late_day_rescue: "TODAY IS STILL OPEN",
  active_next_step: "KEEP IT MOVING",
};

function getDefaultChip(intervention) {
  const key = intervention?.dominant_nudge?.key || "";
  if (CHIP_BY_KEY[key]) return CHIP_BY_KEY[key];
  if (intervention?.state === "reentry") return "PICK THIS BACK UP";
  if (intervention?.state === "dormant") return "START SMALL";
  if (intervention?.state === "drift") return "DON'T LET TODAY SLIP";
  return "KEEP IT MOVING";
}


export function buildDominantInterventionViewModel(intervention) {
  const nudge = intervention?.dominant_nudge;
  const action = intervention?.primary_action;
  if (!nudge || !action) return null;

  return {
    key: nudge.key,
    state: intervention?.state || "active",
    family: nudge.family || intervention?.state || "active",
    window: intervention?.delivery_context?.window || "ambient",
    chip: getDefaultChip(intervention),
    title: nudge.title || intervention?.card_copy?.title || "",
    body: nudge.body || intervention?.card_copy?.body || "",
    tone: intervention?.card_copy?.tone || "momentum",
    primaryActionKey: action.key,
    primaryActionLabel: action.cta_label,
    primaryActionRoute: intervention?.cta_route || "",
    partnerContextLine:
      intervention?.comparison_suppressed ? "" : intervention?.partner_context_line || "",
    supportingLine: intervention?.supporting_context?.restart_prompt || "",
    successMessage: intervention?.supporting_context?.success_message || "",
    reentryVariant: intervention?.reentry_variant || null,
    comparisonSuppressed: Boolean(intervention?.comparison_suppressed),
    partnerContextAllowed: Boolean(intervention?.partner_context_allowed),
  };
}
